import { State } from "../types";

export function saveRuleFail(
  state: State,
  payload: SaveRuleFail["payload"]
): State {
  const { errorCode, errorDescription } = payload;
  console.log("errorCode: ", errorCode);

  return {
    ...state,
    asyncStatus: "idle",
    saveError: { code: errorCode, description: errorDescription },
  };
}

export type SaveRuleFail = {
  type: "saveRuleFail";
  payload: {
    errorCode?: string;
    errorDescription?: unknown;
  };
};
